import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const setDependent = info => call(websocketFetch, 'set_dependent', info);
